import { breakpoints, Button, Dialog, Inline, Stack } from '@etg/wings';
import { DangerousHtmlContent } from '@eti/components';
import type { ReactNode } from 'react';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import StyledOrderList from '../styled-order-list/StyledOrderList';

const extraMarginStyles = css`
  margin-top: 16px;
`;
interface CFCModalProps {
  bottomContent?: ReactNode;
  isOpen: boolean;
  onDismissModal?: () => void;
  onProceedButtonClicked?: () => void;
  setIsOpen: (arg: boolean) => void;
  shouldShowProceedButton: boolean;
}

const CFCModal = ({
  bottomContent,
  isOpen,
  onDismissModal,
  onProceedButtonClicked,
  setIsOpen,
  shouldShowProceedButton,
}: CFCModalProps) => {
  const { t } = useTranslation();
  const styledOrderListItems = [
    {
      description: t('Payment.Ryanair.Modal.Step1.Description'),
    },
    {
      description: t('Payment.Ryanair.Modal.Step2.Description'),
    },
    {
      description: t('Payment.Ryanair.Modal.Step3.Description'),
    },
  ];

  const handleOnSubmit = () => {
    if (onProceedButtonClicked) {
      onProceedButtonClicked();
    }
    setIsOpen(false);
  };

  const handleOnDismiss = () => {
    if (onDismissModal) {
      onDismissModal();
    }
    setIsOpen(false);
  };

  return (
    <Dialog
      closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
      data-testid="cfc-modal"
      isOpen={isOpen}
      onDismiss={handleOnDismiss}
      title={t('Payment.Ryanair.Modal.Title')}
    >
      <Stack>
        <DangerousHtmlContent content={t('Payment.Ryanair.Modal.Description')} />
        <StyledOrderList listItems={styledOrderListItems} />
      </Stack>
      <Inline align="end" className={extraMarginStyles} collapseBelow={breakpoints._560}>
        <Button
          data-testid="cfc-modal-close-button"
          onClick={handleOnDismiss}
          variant={shouldShowProceedButton ? 'secondary' : 'primary'}
        >
          {t('Payment.Ryanair.Modal.CloseButton.Description')}
        </Button>
        {shouldShowProceedButton &&
          (bottomContent ?? (
            <Button
              data-testid="cfc-modal-complete-payment-button"
              onClick={handleOnSubmit}
              variant="primary"
            >
              {t('Payment.Ryanair.Modal.ProceedButton.Description')}
            </Button>
          ))}
      </Inline>
    </Dialog>
  );
};

export default CFCModal;
